<template>
  <section>
    <div class="mb-3 flex h-5 items-center justify-between">
      <p class="text-text-neutral-tertiary text-xs">{{ passengerKeyTitle }}</p>
      <button
        v-if="isClearButtonVisible"
        type="button"
        class="text-text-positive-primary text-sm font-semibold"
        @click="clearPassenger"
      >
        {{ t('general.clear') }}
      </button>
    </div>
    <PassengersDataForm
      source-page="passengersData"
      :is-domestic="isDomestic"
      :passenger="passenger"
      :validations="validations"
      :provider-class="providerClass"
      is-citizenship-search-input-visible
      is-popular-countries-visible
      @onPassengerUpdate="emit('onPassengerUpdate', $event)"
    />
  </section>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { isEqual } from 'lodash-es';
  import { PassengersDataForm } from 'freedom-shared';
  import type { Validation } from '@vuelidate/core';
  import type { passengerValidation } from 'shared';
  import type { PassengerKey } from '@aviata/booking-data';

  import { formPassengerConfig } from '@/entities/form-passenger';

  import type { PassengerWithDocType } from '../types';

  const props = defineProps<{
    isDomestic: boolean;
    passenger: PassengerWithDocType;
    passengerKey: PassengerKey;
    validations: Validation<passengerValidation.types.PassengerValidation>;
    providerClass?: string;
  }>();

  const emit = defineEmits<{
    onPassengerUpdate: [PassengerWithDocType];
  }>();

  const { t } = useI18n();

  const passengerKeyTitle = t(
    `passengersData.passengerTypes.${props.passengerKey.slice(0, 3)}.text`,
  );

  const isClearButtonVisible = computed(
    () => !isEqual(props.passenger, formPassengerConfig.emptyPassenger),
  );

  const clearPassenger = () => {
    emit('onPassengerUpdate', formPassengerConfig.emptyPassenger);
    // Drop validation $dirty/$error so error messages disappear immediately.
    props.validations.$reset();
  };
</script>
